import { stringify } from 'qs'

import { lsGet, safeAwait } from 'utils/request'

export const getPhotoTags = (props) => {
  return safeAwait(lsGet(`/photoTags?${stringify(props)}`))
}
